import { FontAwesome5 } from '@expo/vector-icons';
import React, { useState } from 'react';
import { View } from 'react-native';
import { Divider, Menu, useTheme } from 'react-native-paper';

import { OETouchableOpacity } from '../../atoms';

export interface MenuItem {
  label: string;
  onPress: () => void;
}

export interface DropdownMenuProps {
  menuItems: MenuItem[];
  icon?: string;
  color?: string;
  size: number;
  closeOnPress?: boolean;
}

export function DropdownMenu({
  menuItems,
  icon,
  color,
  size,
  closeOnPress,
}: DropdownMenuProps) {
  const { colors } = useTheme();

  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const handlePress = (onPress: () => void) => {
    if (closeOnPress) {
      setIsMenuVisible(false);
    }
    onPress();
  };

  return (
    <Menu
      visible={isMenuVisible}
      onDismiss={() => setIsMenuVisible(false)}
      anchor={
        <OETouchableOpacity
          activeOpacity={0.75}
          onPress={() => setIsMenuVisible(true)}
        >
          <FontAwesome5
            name={icon || 'bars'}
            size={size}
            color={color || colors.background}
          />
        </OETouchableOpacity>
      }
    >
      {menuItems.map((item, i) => (
        <View key={item.label}>
          {i > 0 && <Divider />}
          <Menu.Item
            onPress={() => handlePress(item.onPress)}
            title={item.label}
          />
        </View>
      ))}
    </Menu>
  );
}
